module.exports = __webpack_public_path__ + "website_squircle_charcoal.svg?c54b7c9743627e2f30d480cb1e9f8c3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/website_squircle_charcoal.svg
// module id = 128
// module chunks = 0